/* eslint-disable import/extensions */
import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/no-unresolved
import Localizer from 'thdlocalizer';
import configureStore from './store/configureStore';
import rootReducer from './reducers';
import App from './components/App';

import './utils/mandiThdCookieHack';

// Store Initialization
// ------------------------------------
const store = configureStore(rootReducer); // eslint-disable-line no-underscore-dangle

Localizer.on(Localizer.event.LOCALIZED_STORE_CHANGED, () => {
  const storeInfo = Localizer.getLocalizedStore();
  console.log('storeInfo: ', storeInfo);
});

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('estimateBuilderRoot');
const render = () => {
  const routes = require('./routes/index').default(store); // eslint-disable-line global-require

  ReactDOM.render(<App store={store} routes={routes} />, MOUNT_NODE);
};

// Development Tools
// ------------------------------------
// if (__DEV__) {
//   if (module.hot) {
//     const renderApp = render;
//     const renderError = (error) => {
//       const RedBox = require('redbox-react').default; // eslint-disable-line global-require

//       ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
//     };

//     render = () => {
//       try {
//         renderApp();
//       } catch (e) {
//         // console.error(e);
//         renderError(e);
//       }
//     };

//     // Setup hot module replacement
//     module.hot.accept(['./components/App/sync', './routes/index'], () =>
//       setImmediate(() => {
//         ReactDOM.unmountComponentAtNode(MOUNT_NODE);
//         render();
//       }));
//   }
// }

// Let's Go!
// ------------------------------------
// if (!__TEST__)
render(); // eslint-disable-line no-undef
